import { parseQueryStatNumber } from "./queryBuilder";

const identity = (row, index) => ({
  id: row._id || row.userId || `row-${index}`,
  rank: row.rank ?? index + 1,
  username: row.username,
  level: row.level,
});

export const buildTriviaLeaderboardRows = (rankings = [], type = "global") =>
  rankings.map((row, index) => {
    const base = identity(row, index);

    if (type === "daily") {
      return {
        id: base.id,
        rank: base.rank,
        username: base.username,
        score: parseQueryStatNumber(row.score) ?? 0,
        accuracy: parseQueryStatNumber(row.accuracy) ?? 0,
      };
    }

    if (type === "streak") {
      return {
        ...base,
        bestStreak: parseQueryStatNumber(row.bestStreak) ?? 0,
        currentStreak: parseQueryStatNumber(row.currentStreak) ?? 0,
        totalGamesPlayed: parseQueryStatNumber(row.totalGamesPlayed) ?? 0,
      };
    }

    if (type === "speed") {
      return {
        ...base,
        averageTimePerQuestion: parseQueryStatNumber(row.averageTimePerQuestion) ?? 0,
        totalGames: parseQueryStatNumber(row.totalGames) ?? 0,
        fastestGame: parseQueryStatNumber(row.fastestGame) ?? 0,
      };
    }

    return {
      ...base,
      totalScore: parseQueryStatNumber(row.totalScore) ?? 0,
      gamesPlayed: parseQueryStatNumber(row.gamesPlayed) ?? 0,
      accuracy: parseQueryStatNumber(row.accuracy) ?? 0,
    };
  });
